import type { TopBarContextType } from 'features/project/partials/project-layout/contexts/use-top-bar'
import { useTopBar as useProjectLayoutTopBar } from 'features/project/partials/project-layout/contexts/use-top-bar'

export const useTopBar = (): TopBarContextType => useProjectLayoutTopBar()
